import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import {
  EstructuraReporte, ColumnaFuenteDatosEstructura, Base,
} from '@app/shared';

@Injectable()
export class ReportsStructureDataService {
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) {}

  /**
   * Consulta la estructura de un reporte
   *
   * @param {number} idReport
   * @returns {Observable<EstructuraReporte[]>}
   * @memberof ReportsStructureDataService
   */
  getStructureReports(idReport: number): Observable<EstructuraReporte[]> {
    return new Observable(obs => {
      this.http.get<EstructuraReporte[]>(this.api.get('structureReport', [idReport])).subscribe(
        structure => {
          if (structure && structure.length) {
            structure.sort((a, b) => a.id - b.id);
          }
          if (structure && structure.length) {
            structure.forEach(el => {
              const newData: ColumnaFuenteDatosEstructura = {
                id_forma: el.dato.id_forma,
                id_tarea: el.dato.id_tarea
              };
              if (el.dato['campo-interno']) {
                newData.campo_interno = el.dato['campo-interno'];
              } else if (el.dato['campo-forma']) {
                newData.campo_forma = el.dato['campo-forma'];
              } else if (el.dato['campo-tabla']) {
                newData.campo_tabla = el.dato['campo-tabla'];
              } else if (el.dato['tarea-documento']) {
                newData.tarea_documento = el.dato['tarea-documento'];
              }
              el.dato = newData;
            });
          }
          obs.next(structure);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Agrega una columna a la estructura del reporte
   *
   * @param {EstructuraReporte} structure
   * @returns {Observable<boolean>}
   * @memberof ReportsStructureDataService
   */
  addStructureReports(structure: EstructuraReporte): Observable<boolean> {
    return new Observable(obs => {
      if (structure.tipo_campo) {
        structure['tipo'] = structure.tipo_campo;
        delete structure.tipo_campo;
      }
      if (structure.dato && structure.dato.id_tarea) {
        const structureDato: any = {
          id_forma: structure.dato.id_forma,
          id_tarea: structure.dato.id_tarea
        };
        if (structure.dato.campo_interno) {
          structureDato['campo-interno'] = structure.dato.campo_interno;
        } else if (structure.dato.campo_forma) {
          structureDato['campo-forma'] = structure.dato.campo_forma;
        } else if (structure.dato.campo_tabla) {
          structureDato['campo-tabla'] = structure.dato.campo_tabla;
        } else if (structure.dato.tarea_documento) {
          structureDato['tarea-documento'] = structure.dato.tarea_documento;
        }
        structure.dato = structureDato;
      }
      let formData = new FormData();
      formData.append('datos', JSON.stringify(structure));
      if (structure.imagen){
        formData.append('imagen', structure.imagen);
      }
      this.http.post<boolean>(this.api.get('structureReport'), formData).subscribe(
        resp => {
          obs.next(true);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Actualiza la informacion de una columna de la estructura de un reporte
   *
   * @param {number} idStructureReport
   * @param {EstructuraReporte} structure
   * @returns {Observable<boolean>}
   * @memberof ReportsStructureDataService
   */
  updateStructureReports(idStructureReport: number, structure: EstructuraReporte): Observable<boolean> {
    return new Observable(obs => {
      if (structure.tipo_campo) {
        structure['tipo'] = structure.tipo_campo;
        delete structure.tipo_campo;
      }
      if (structure.dato && structure.dato.id_tarea) {
        const structureDato: any = {
          id_forma: structure.dato.id_forma,
          id_tarea: structure.dato.id_tarea
        };
        if (structure.dato.campo_interno) {
          structureDato['campo-interno'] = structure.dato.campo_interno;
        } else if (structure.dato.campo_forma) {
          structureDato['campo-forma'] = structure.dato.campo_forma;
        } else if (structure.dato.campo_tabla) {
          structureDato['campo-tabla'] = structure.dato.campo_tabla;
        } else if (structure.dato.tarea_documento) {
          structureDato['tarea-documento'] = structure.dato.tarea_documento;
        }
        structure.dato = structureDato;
      }
      let formData = new FormData();
      formData.append('datos', JSON.stringify(structure));
      if (structure.imagen){
        formData.append('imagen', structure.imagen);
      }
      this.http.put<boolean>(this.api.get('structureReport', [idStructureReport]), formData).subscribe(
        resp => {
          obs.next(true);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Elimina la columna de la estuctura de un reporte
   *
   * @param {number} idStructureReport
   * @returns {Observable<boolean>}
   * @memberof ReportsStructureDataService
   */
  deleteStructureReports(idStructureReport: number): Observable<boolean> {
    return new Observable(obs => {
      this.http.delete<boolean>(this.api.get('structureReport', [idStructureReport])).subscribe(
        resp => {
          obs.next(true);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Consulta de los tipos de parametros(columnas) para una columna de la estructura de un reporte
   *
   * @returns {Observable<Base[]>}
   * @memberof ReportsStructureDataService
   */
  getTypesParametersReports(): Observable<Base[]> {
    return new Observable(obs => {
      this.http.get<Base[]>(this.api.get('typeReportParameter')).subscribe(
        types => {
          obs.next(types);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-reports/reports/reports-structure/shared/reports-structure.data.service.ts